<template>
  <div>
    <navigation-bar></navigation-bar>
    <div class="main">
      <el-row>
        <!-- 左侧导航栏 -->
        <el-col :span="4">
          <div class="sidebar">
            <div class="sidebar_title">支持与服务</div>
            <div class="sidebar_item" :class='{active: index === number}' v-for="(item, index) in typeList" :key="index" @click="change(index)">
              {{item.name}}
            </div>
          </div>
        </el-col>
        <!-- 内容 -->
        <el-col :span="16">
          <create-workorder v-if="number == 0"></create-workorder>
          <my-workorder v-if="number == 1"></my-workorder>
          <common-probsolutions v-if="number == 3"></common-probsolutions>
          <feedback v-if="number == 4"></feedback>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import NavigationBar from '../../../components/console/navigationBar.vue'
import CreateWorkorder from './rightContent/createWorkorder.vue'
import MyWorkorder from './rightContent/myWorkorder.vue'
import CommonProbsolutions from './rightContent/commonProbsolutions.vue'
import Feedback from './rightContent/feedback.vue'

export default {
  components: {
    NavigationBar,
    CreateWorkorder,
    MyWorkorder,
    CommonProbsolutions,
    Feedback
  },
  data() {
    return {
      typeList: [
        {name: '创建工单'},
        {name: '我的工单'},
        {name: '在线客服'},
        {name: '常见问题及解决方案'},
        {name: '反馈及意见'}
      ],
      number: 0,
    }
  },
  watch: {
	    // 监听路由地址的改变
	    $route:{
	        immediate:true,
	        handler(){
	            if(this.$route.query.index){
                this.number = this.$route.query.index - 0;
	            }
	        }
	    },
	},
  methods: {
    change(index) {
      if(this.$route.query.index == index) {
        return;
      } else {
        this.$router.push({path: '/supportServices',query:{index}});
      }
    }
  },
}
</script>

<style lang="scss" scoped="scoped">
.main {
  margin-top: 80px;
  .sidebar {
    width: 80%;
    height: 1200px;
    color: #4F4F4F;
    border-right: 1px solid #E5E5E5;
    .sidebar_title {
        height: 79px;
        border-bottom: 1px solid #E5E5E5;
        text-align: center;
        line-height: 79px;
    }
    .sidebar_item {
      height: 47px;
      font-size: 14px;
      text-align: center;
      line-height: 47px;
    }
    .active {
      background-color: #F8F9FF;
      color: #537EEE;
      border-right: 4px solid #537EEE;
    }
    .sidebar_item:hover {
      cursor: pointer;
      background-color: #F8F9FF;
      color: #537EEE;
    }
  }
}
</style>